import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BrandedLayout } from './components';
import { Login } from './pages/Login';
import { Registration } from './pages/Registration';
import { Settings } from './pages/Settings';
import { Consent } from './pages/Consent';
import { Recovery } from './pages/Recovery';
import { Verification } from './pages/Verification';
import { Mfa } from './pages/Mfa';
import { FlowError } from './pages/FlowError';
import { Logout } from './pages/Logout';
import { Home } from './pages/Home';
import { Help } from './pages/Help';

function App() {
  return (
    <Router>
      <BrandedLayout>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/consent" element={<Consent />} />
          <Route path="/recovery" element={<Recovery />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/mfa" element={<Mfa />} />
          <Route path="/error" element={<FlowError />} />
          <Route path="/logout" element={<Logout />} />
          {/* Information and How-Tos: /help, /help/:section, /help/:section/:page.
              Public — readable with or without a session. */}
          <Route path="/help/*" element={<Help />} />
          {/* Landing page for a signed-in visitor; it redirects to /login
              itself when there is no session. */}
          <Route path="/" element={<Home />} />
        </Routes>
      </BrandedLayout>
    </Router>
  );
}

export default App;
